export class FileReferenceModel {
  REF: string; // "A-1"
  engleftsidedocid: number; // 3053
  engteamclientdocid: number; // 2953
  extension: string; // "docx"
  extensionspath: string; // "/assets/images/extension/word.svg"
  fileNameWithoutExt: string; // "A-1-clientside notn"
  filename: string; // "A-1-clientside notn.docx"
  filepath: string; // "Engagements/1997_Firm/1662_Client/1364_Engagements/EngagementDocs/Procedure/Current Assets/A
                    // Cash And Cash Equivalents"
  mssdkfileid: string; // "0a54a0e6-6e9a-4b24-840c-be3a4e54b923"
  size: string; // "42659"
  sizeinbytes: string; // "42.0 KB"
  submoduleid: number; // 477
}

export class AddRefModel {
  engleftsidedocid: number;
  engteamclientdocid: number;
  extension: string;
  filepath: string;
  filename: string;
  REF: string;
  mssdkfileid: string;
}
